import { createIcon } from './create-icon'

export const ArrowRight = createIcon({
  displayName: 'ArrowRight',
  paths: [
    'M745.109 733.551l181.035-181.035c8.341-8.341 12.51-19.251 12.51-30.165 0-2.726-0.26-5.457-0.781-8.145-1.566-8.064-5.474-15.765-11.729-22.020l-0.047-0.043-180.988-180.992c-16.64-16.64-43.648-16.64-60.331 0-16.64 16.683-16.64 43.691 0 60.331l108.194 108.198h-664.985c-23.595 0-42.667 19.115-42.667 42.667s19.072 42.667 42.667 42.667h664.998l-108.207 108.207c-16.64 16.64-16.64 43.648 0 60.331 16.683 16.64 43.691 16.64 60.331 0z'
  ]
})
